import { FeedbackPageData, FeedbackPageFlow, FeedbackPageType } from './types'

export const feedbackPageData: FeedbackPageData = {
  'pt-BR': {
    [FeedbackPageFlow.EDIT_ALIAS]: {
      [FeedbackPageType.SUCCESS]: {
        title: 'Alias atualizado com sucesso',
        primaryButton: 'Continuar',
      },
      [FeedbackPageType.ERROR]: {
        title: 'Houve um erro por aqui',
        primaryButton: 'Continuar',
      },
    },
    [FeedbackPageFlow.BANK_NOTE_WORLD_CUP_SEARCH]: {
      [FeedbackPageType.SUCCESS]: {
        title: 'Agradecemos pela participação!',
        primaryButton: 'Continuar',
      },
      [FeedbackPageType.ERROR]: {
        title: 'Erro ao enviar sua avaliação',
        primaryButton: 'Tentar novamente',
      },
    },
  },
  'en-US': {
    [FeedbackPageFlow.EDIT_ALIAS]: {
      [FeedbackPageType.SUCCESS]: {
        title: 'Alias saved successfully',
        primaryButton: 'Continue',
      },
      [FeedbackPageType.ERROR]: {
        title: 'There was an error around here',
        primaryButton: 'Continue',
      },
    },
  },
  'es-ES': {
    [FeedbackPageFlow.EDIT_ALIAS]: {
      [FeedbackPageType.SUCCESS]: {
        title: 'Alias guardado con éxito',
        primaryButton: 'Continuar',
      },
      [FeedbackPageType.ERROR]: {
        title: 'Hubo un error por aquí',
        primaryButton: 'Continuar',
      },
    },
  },
}
